module.exports = __webpack_public_path__ + "img/maths.435f734f.jpg";